export const ALARM_EMAIL_LOAD = 'ALARM_EMAIL_LOAD';
export const ALARM_EMAIL_LOAD_SUCCESS = 'ALARM_EMAIL_LOAD_SUCCESS';
export const ALARM_EMAIL_LOAD_ERROR = 'ALARM_EMAIL_LOAD_ERROR';
export const ALARM_EMAIL_ADD = 'ALARM_EMAIL_ADD';
export const ALARM_EMAIL_ADD_SUCCESS = 'ALARM_EMAIL_ADD_SUCCESS';
export const ALARM_EMAIL_ADD_ERROR = 'ALARM_EMAIL_ADD_ERROR';
export const ALARM_EMAIL_UPDATE = 'ALARM_EMAIL_UPDATE';
export const ALARM_EMAIL_UPDATE_SUCCESS = 'ALARM_EMAIL_UPDATE_SUCCESS';
export const ALARM_EMAIL_UPDATE_ERROR = 'ALARM_EMAIL_UPDATE_ERROR';
export const ALARM_EMAIL_DELETE = 'ALARM_EMAIL_DELETE';
export const ALARM_EMAIL_DELETE_SUCCESS = 'ALARM_EMAIL_DELETE_SUCCESS';
export const ALARM_EMAIL_DELETE_ERROR = 'ALARM_EMAIL_DELETE_ERROR';
